import { toastr } from 'react-redux-toastr'

const errorOptions = {
  timeOut: 5000
}

const warningOptions = {
  timeOut: 5000
}

const infoOptions = {
  timeOut: 2000
}

const successOptions = {
  timeOut: 2000
}

export const ShowErrorDispatch = (dispatch) => {
  return (message, options) => {
    toastr.error('Error', message, options || errorOptions)
  }
}

export const ShowWarningDispatch = (dispatch) => {
  return (message, options) => {
    toastr.warning('Warning', message, options || warningOptions)
  }
}

export const ShowInfoDispatch = (dispatch) => {
  return (message, options) => {
    toastr.info('Info', message, options || infoOptions)
  }
}

export const ShowSuccessDispatch = (dispatch) => {
  return (message, options) => {
    toastr.success('Success', message, options || successOptions)
  }
}
